import React, { useEffect, useState } from 'react'
import SocialMedia from '../../component/SocialMedia/socialMedia'
import { FaTools } from 'react-icons/fa' 
import TechnicalSkills from '../../models/TechnicalSkills'

// derive core skill list from TechnicalSkills
const techModel = new TechnicalSkills()
const allSkills = Object.values(techModel.toObject()).flat()
const prefer = ['React','JavaScript','TypeScript','HTML/CSS','TailwindCSS','Node.js','Git']
const levelMap = { React: 90, JavaScript: 95, TypeScript: 80, 'HTML/CSS': 95, TailwindCSS: 70, 'Node.js': 75, Git: 85 }

const skills = prefer.filter(name => name === 'HTML/CSS' || allSkills.includes(name)).map(name => ({ name, level: levelMap[name] || 70 }))

// full categorized skills from the TechnicalSkills model
const skillsByCategory = new TechnicalSkills().toObject()

function Skills() {
  const [scrollY, setScrollY] = useState(0)

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY)
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <div style={{ fontFamily: "'Roboto', sans-serif", margin: 0, padding: 0 }}>
      {/* Hero */}
      <section style={{ height: '48vh', minHeight: 360, display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center', background: 'linear-gradient(135deg, #667eea, #764ba2)', color: '#fff', padding: '0 20px', opacity: scrollY < 80 ? 1 : 0.95, transition: 'opacity 0.6s ease' }}>
        <div>
          <FaTools style={{ fontSize: 48, marginBottom: 10 }} />
          <h1 style={{ fontSize: '40px', fontWeight: 700, margin: '6px 0 12px', transform: `translateY(${scrollY * 0.05}px)`, transition: 'transform 0.3s ease-out' }}>Skills</h1>
          <p style={{ fontSize: '18px', maxWidth: 820, margin: '0 auto', lineHeight: 1.6 }}>Tools and technologies I use to build modern, accessible, and performant web applications.</p>
        </div>
      </section>

      <main style={{ maxWidth: '1000px', margin: '0 auto', padding: '80px 20px 60px 20px' }}>
        <section style={{ marginBottom: '40px', opacity: scrollY > 50 ? 1 : 0, transform: scrollY > 50 ? 'translateY(0)' : 'translateY(20px)', transition: 'all 0.7s ease-out' }}>
          <h2 style={{ fontSize: '28px', borderBottom: '3px solid #667eea', display: 'inline-block', paddingBottom: '6px', color: '#333', marginBottom: '14px' }}>Technical Skills</h2>
          <div style={{ marginTop: 16 }}>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: 18 }}>
              {Object.entries(skillsByCategory).map(([category, items]) => (
                <div key={category} style={{ background: '#fff', padding: 16, borderRadius: 10, boxShadow: '0 6px 18px rgba(0,0,0,0.06)' }}>
                  <h3 style={{ margin: '0 0 8px', fontSize: 18 }}>{category}</h3>
                  <ul style={{ margin: 0, padding: 0, listStyle: 'none', color: '#555' }}>
                    {items.map((it) => (
                      <li key={it} style={{ margin: '6px 0' }}>{it}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section style={{ marginTop: 30, textAlign: 'center' }}>
          <h2 style={{ fontSize: '26px', borderBottom: '3px solid #667eea', display: 'inline-block', paddingBottom: '6px', color: '#333', marginBottom: '18px' }}>Want to collaborate?</h2>
          <p style={{ color: '#555' }}>I'm available for freelance and contract work — let's build something great together.</p>

          <SocialMedia size={44} />
        </section>
      </main>

      {/* Footer */}
      <footer style={{ textAlign: 'center', padding: '36px 20px', background: '#333', color: '#fff' }}>
        <p style={{ margin: 0 }}>&copy; {new Date().getFullYear()} Your Name. All rights reserved.</p>
      </footer>
    </div>
  )
}

export default Skills